import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  detail: null,
};

export const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    addPlan: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPlan: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOnePlan: (state) => {
      state.loading = true;
      state.error = null;
    },
    successPlan: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = Array.isArray(action.payload) ? action.payload : [];
    },
    successOnePlan: (state, action) => {
      state.loading = false;
      state.error = null;
      state.detail = action.payload || null;
    },
    failedPlan: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removePlan: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatePlan: (state) => {
      state.loading = true;
      state.error = null;
    },
  },
});

export const {
  addPlan,
  getPlan,
  getOnePlan,
  successPlan,
  successOnePlan,
  failedPlan,
  removePlan,
  updatePlan,
} = planSlice.actions;

export default planSlice.reducer;
